"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurancePlanGeneralCost = void 0;
/**
 * Details of a Health Insurance product/plan provided by an organization.
 */
var InsurancePlanGeneralCost = /** @class */ (function () {
    function InsurancePlanGeneralCost() {
    }
    return InsurancePlanGeneralCost;
}());
exports.InsurancePlanGeneralCost = InsurancePlanGeneralCost;
